<template>
    <div id="newsletter-roberta" class="d-flex flex-justify-between">
        <div class="form-wrapper">
            <template v-if="!registered">
                <h3 class="newsletter-form-title">
                    Seu cachorro morde?
                    <br v-if="isMobile" />
                    Não, ela avisa das promoções
                </h3>
                <p>
                    Digite seu melhor e-mail que a Roberta vai te avisar das nossas promos.
                    <br v-if="isMobile" />
                    É sério, ela avisa.
                </p>
                <form id="footer-promo-subscribe">
                    <Alert :alert="newsletterAlert" />
                    <TextField
                        class="mt-4"
                        id="promo-footer-nome"
                        autocomplete="nome"
                        v-model="fields.name"
                        placeholder="Seu nome"
                        type="text"
                    />
                    <div class="input-mail-send">
                        <TextField
                            id="promo-footer-email"
                            autocomplete="email"
                            v-model="fields.email"
                            placeholder="Seu email"
                            type="email"
                            class="d-flex"
                            :style="{ width: '100%' }"
                        />
                        <LoadingButton
                            :loading="busy"
                            @click="subscribe"
                            class="btn btn-small text-uppercase send-btn disabled"
                        >
                            Enviar
                        </LoadingButton>
                    </div>
                </form>
            </template>
            <template v-else>
                <h3 class="newsletter-form-title">Agradecemos seu interesse!</h3>
                <p class="mt-4">
                    Agora é só deixar com a gente. A Roberta vai avisar das promos e latir, as
                    vezes.
                </p>
                <div class="send-btn-closed d-flex flex-justify-center flex-align-center">
                    <p>Seu e-mail foi cadastrado com sucesso!</p>
                </div>
            </template>
        </div>
        <div class="roberta-assistant">
            <picture>
                <source
                    :srcset="`${$scope.CDN_IMAGES}/images/hotsites/aniversario/birthday-roberta-mobile.png?auto=compress,format&q=65`"
                    media="(max-width: 767px)"
                />
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/aniversario/birthday-roberta.png?auto=compress,format&q=65`"
                    alt="Roberta Assistente de Cãomunidade"
                />
            </picture>
            <p>
                <strong class="text-uppercase">Roberta</strong>
                <br />Assistente de Cãomunidade Chico Rei
            </p>
        </div>
    </div>
</template>

<script>
    import Alert from '../../../../../../submodules/src/componentsV2/surface/alert/Alert.vue';
    import TextField from '../../../../../../submodules/src/components/input/text-field/TextField.vue';
    import LoadingButton from '../../common/LoadingButton.vue';
    import { resizeOrientationAware } from '../../../../../../submodules/src/script/common';
    import { customerService } from '../../../../../../submodules/src/service/resource';

    export default {
        name: 'NewsletterRoberta',
        components: {
            Alert,
            TextField,
            LoadingButton,
        },

        data() {
            return {
                registered: false,
                busy: false,
                newsletterAlert: null,
                isMobile: false,
                fields: {
                    name: this.$scope.id ? this.$scope.CUSTOMER.NAME : null,
                    email: this.$scope.id ? this.$scope.CUSTOMER.EMAIL : null,

                    promo: true,
                    releases: true,
                    content: true,
                },
            };
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 768;
            },

            subscribe() {
                this.busy = true;

                let promise;
                if (this.$scope.id && this.$scope.CUSTOMER.EMAIL === this.fields.email) {
                    promise = customerService.update(this.$scope.id, {
                        news_promo: this.fields.promo,
                        news_colecao: this.fields.releases,
                        news_conteudo: this.fields.content,
                        unsubscribe: !(
                            this.fields.promo ||
                            this.fields.releases ||
                            this.fields.content
                        ),
                    });
                } else {
                    promise = this.axios.api.post('/get_response/subscribe', {
                        name: this.fields.name,
                        email: this.fields.email,
                        newsPromo: this.fields.promo,
                        newsColecao: this.fields.releases,
                        newsConteudo: this.fields.content,
                        frequency: 1,
                    });
                }

                promise
                    .then(() => this.onNewsletterSuccess())
                    .catch((error) => this.onNewsletterFailed(error))
                    .then(() => (this.busy = false));
            },

            onNewsletterSuccess() {
                this.registered = true;
                this.newsletterAlert = {
                    message: 'Newsletter assinada com sucesso',
                };
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'subscribe-aniversario',
                });
            },

            onNewsletterFailed(error) {
                this.newsletterAlert = {
                    message: error.response.data.message || 'Não foi possível assinar a newsletter',
                    isError: true,
                };
            },
        },
    };
</script>
